import React from "react";
import { connect } from 'react-redux'

// @material-ui/icons
import RecordVoiceOverIcon from "@material-ui/icons/RecordVoiceOver";
import StrikethroughS from "@material-ui/icons/StrikethroughS";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import InputAdornment from "@material-ui/core/InputAdornment";

// core components
import Button from "components/CustomButtons/Button.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import MultiInput from "views/Components/MultiInput.jsx"
import InputLabel from "@material-ui/core/InputLabel";

// @material-ui/core components
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
// import InputLabel from "@material-ui/core/InputLabel";
import LinearProgress from '@material-ui/core/LinearProgress';

//symbols
import {
  symbolSave,
  symbolsFetch,
  symbolFetch,
  symbolFilter,
  fetchAllSymbols
} from 'actions/symbols'
import { currenciesFetch, currencyFilter } from 'actions/currencies'
import { symbolGroupsFetch, symbolGroupFilter } from 'actions/symbolGroups'
import {
  danger,
  success,
} from 'actions/notification'

//styles
import styles from "assets/jss/material-dashboard-pro-react/views/form";
import { symbolTypes } from 'enums'
class Form extends React.Component {
  state = {
    form: {
      symbolId: 0,
      name: '',
      aliases: [],
      baseCurrencyId: null,
      lotSize: 0,
      pipSize: 0,
      priceFeedSymbol: '',
      quoteCurrencyId: null,
      parentSymbolId: null,
      type: 'FOREX',
      groupId: null,
      childrenSymbols: []
    },
    showBaseCurrencyId: true,
    allSymbols: [],
    oldSymbols: [],
    isFetching: true
  }
  componentDidMount() {
    const editMode = this.props.match.params.id
    this.props.currencyFilter({ size: 100000 })
    this.props.currenciesFetch()
    this.props.symbolGroupFilter({ size: 100000 })
    this.props.symbolGroupsFetch()
    let symbols = []
    this.props.fetchAllSymbols().then((res) => {
      symbols = res.content

      let availableSymbols = symbols
      if (editMode) { //  remove it self if edit mode
        availableSymbols = symbols.filter((x) => x.symbolId !== Number(editMode))

        this.props.fetch(this.props.match.params.id)
          .then(e => {
            const children = symbols.filter((symb) => {
              return symb.parentSymbolId === e.symbolId
            })

            this.setState({
              ...this.state,
              form: {
                ...e,
                baseCurrencyId: e.baseCurrency.currencyId,
                quoteCurrencyId: e.quoteCurrency.currencyId,
                childrenSymbols: children.map((x) => x.symbolId)
              },
              oldSymbols: children,
              isFetching: false
            })
          })
      }
      availableSymbols.sort((a, b) => a.name.localeCompare(b.name));
      this.setState({ allSymbols: availableSymbols, isFetching: false })
    })

    let orderedSymbolTypes = {};
    Object.keys(symbolTypes).sort().forEach(function(key) {
      orderedSymbolTypes[key] = symbolTypes[key];
    });

    this.setState({ symbolTypes: orderedSymbolTypes })
  }

  //Submit form
  submit(e) {
    if (e.preventDefault)
      e.preventDefault();
    const { oldSymbols } = this.state
    let values = this.state.form

    if (values.groupId === -1) {
      values.groupId = null
    }
    this.props.save(values)
      .then(e => {
        // save children
        this.state.form.childrenSymbols.forEach((childId) => {
          let childObj = this.state.allSymbols.find((x) => x.symbolId === childId)
          childObj.parentSymbolId = e.symbolId
          childObj.baseCurrencyId = childObj.baseCurrency.currencyId
          childObj.quoteCurrencyId = childObj.quoteCurrency.currencyId
          this.props.save(childObj)
        })

        oldSymbols.forEach((symbolObj) => {
          let symbol = this.state.form.childrenSymbols.find((x) => x === symbolObj.symbolId)
          if (symbol) return;
          symbolObj.parentSymbolId = null
          symbolObj.baseCurrencyId = symbolObj.baseCurrency.currencyId
          symbolObj.quoteCurrencyId = symbolObj.quoteCurrency.currencyId
          this.props.save(symbolObj)
        })

        this.props.success(e.name + ' ' + (e.symbolId ? 'Edited' : 'Added') + '!', 4);
        this.props.history.goBack()
      })
      .catch(e => { this.props.danger(e + '', 4); })
  }
  //OnChange action for all inputs and selects
  change(event, name) {
    this.setState({
      ...this.state,
      form: {
        ...this.state.form,
        [name]: event.target.value
      },
    })

    if (name==="type") {
      
      if (event.target.value==="FOREX") {
        this.setState({showBaseCurrencyId:true});
      } else
        this.setState({showBaseCurrencyId:false});
      }

  }

  changeMultiselect(values) {
    this.setState({
      ...this.state,
      form: {
        ...this.state.form,
        aliases: values
      }
    })

  }

  getInput(data) {
    return <CustomInput
      labelText={< span > {
        data.name
      }
        {
          (data.required
            ?
            <small>(required)</small>
            : data.required)
        } </span>}
      id={data.key}
      formControlProps={{
        fullWidth: true
      }}
      inputProps={{
        onChange: event => this.change(event, data.key),
        required: data.required,
        value: (this.state.form[data.key] === null ? '' : this.state.form[data.key]),
        type: data.type,
        endAdornment: (data.icon
          ? <InputAdornment position="end" className={this.props.classes.inputAdornment}>
            {data.icon}
          </InputAdornment>
          : '')
      }} />
  }
  render() {

    const { classes, currencies, symbolGroups } = this.props;
    const { allSymbols, symbolTypes, showBaseCurrencyId } = this.state

    return (

      <GridContainer justify="center">
          <GridItem xs={12} sm={8}>
            <Card>
              <CardBody>
      {//Show progress onFetch
      (this.state.isFetching)
        ? <LinearProgress />
        : <form
                  onSubmit={this.submit.bind(this)}
                >
                  <GridContainer justify="center">
                    {/*Header Information*/}
                    <GridItem xs={12} sm={12}>
                      <h4 className={classes.infoText}>
                        Complete information
                    </h4>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={12} lg={10}>
                      {/*Name input*/}
                      {this.getInput({
                        key: 'name',
                        name: 'Name',
                        icon: <RecordVoiceOverIcon className={this.props.classes.inputAdornmentIcon} />,
                        type: 'text',
                        required: true
                      })
                      }
                    </GridItem>
                    <GridItem xs={12} sm={12} md={12} lg={10}>
                      {this.getInput({ key: 'lotSize', name: 'Lot Size', type: 'number' })}
                    </GridItem>
                    <GridItem xs={12} sm={12} md={12} lg={10}>
                      {this.getInput({ key: 'pipSize', name: 'Pip Size', type: 'number' })}
                    </GridItem>
                    <GridItem xs={12} sm={12} md={12} lg={10}>
                      <FormControl
                        fullWidth
                        className={classes.selectFormControl}
                        style={{ paddingTop: '27px', marginBottom: '17px' }}
                      >
                        <InputLabel htmlFor="type" className={classes.selectLabel} >
                          {'Type'}
                        </InputLabel>
                        <Select
                          value={this.state.form.type || 'FOREX'}
                          MenuProps={{ className: classes.selectMenu }}
                          classes={{ select: classes.select }}
                          inputProps={{
                            onChange: event => this.change(event, "type"),
                            id: "type"
                          }}>
                          {Object.values(symbolTypes).map(item =>
                            <MenuItem key={item.value} value={item.value}>{item.value}</MenuItem>
                          )}
                        </Select>
                      </FormControl>
                    </GridItem>
                    { showBaseCurrencyId &&
                    <GridItem xs={12} sm={12} md={12} lg={10}>
                      {/*Base currency*/}
                      <FormControl
                        fullWidth
                        className={classes.selectFormControl}
                        style={{ paddingTop: '27px', marginBottom: '17px' }}
                      >
                        <Select
                          value={this.state.form.baseCurrencyId || -1}
                          MenuProps={{ className: classes.selectMenu }}
                          classes={{ select: classes.select }}
                          inputProps={{
                            onChange: event => this.change(event, "baseCurrencyId"),
                            id: "baseCurrencyId"
                          }}>
                          <MenuItem key={-1} value={-1} disabled>
                            Base Currency
                          </MenuItem>
                          {Object.values(currencies).map(item =>
                            <MenuItem key={item.currencyId} value={item.currencyId}>{item.name}</MenuItem>
                          )}
                        </Select>
                      </FormControl>
                    </GridItem>
                  }
                    <GridItem xs={12} sm={12} md={12} lg={10}>
                      {/*Quote currency*/}
                      <FormControl
                        fullWidth
                        className={classes.selectFormControl}
                        style={{ paddingTop: '27px', marginBottom: '17px' }}
                      >
                        <Select
                          value={this.state.form.quoteCurrencyId || -1}
                          MenuProps={{ className: classes.selectMenu }}
                          classes={{ select: classes.select }}
                          inputProps={{
                            onChange: event => this.change(event, "quoteCurrencyId"),
                            id: "quoteCurrencyId"
                          }}>
                          <MenuItem key={-1} value={-1} disabled>
                            Quote Currency
                          </MenuItem>
                          {Object.values(currencies).map(item =>
                            <MenuItem key={item.currencyId} value={item.currencyId}>{item.name}</MenuItem>
                          )}
                        </Select>
                      </FormControl>
                    </GridItem>

                    

                    <GridItem xs={12} sm={12} md={12} lg={10}>
                      {/*Price feed symbol input*/}
                      {this.getInput({
                        key: 'priceFeedSymbol',
                        name: 'Price Feed Symbol',
                        icon: <StrikethroughS className={this.props.classes.inputAdornmentIcon} />,
                        type: 'text',
                        required: false
                      })
                      }
                    </GridItem>

                    {/* <GridItem xs={12} sm={12} md={12} lg={10}>
                      <FormControl
                          fullWidth
                          className={classes.selectFormControl}
                          style={{paddingTop:'27px', marginBottom: '17px'}}
                        >
                          <Select
                            value={this.state.form.parentSymbolId || -1 }
                            MenuProps={{ className: classes.selectMenu }}
                            classes={{ select: classes.select }}
                            inputProps={{
                              onChange:event => this.change(event, "parentSymbolId"),
                              id: "parentSymbolId"
                            }}>
                            <MenuItem key={-1} value={-1} disabled>
                              Base Symbol (Contract)
                            </MenuItem>
                            {Object.values(baseSymbols).map(item =>
                              <MenuItem key={item.symbolId} value={item.symbolId}>{item.name}</MenuItem>
                            )}
                          </Select>
                        </FormControl>
                  </GridItem> */}
                    <GridItem xs={12} sm={12} md={12} lg={10}>
                      <FormControl
                        fullWidth
                        className={classes.selectFormControl}
                        style={{ paddingTop: '27px', marginBottom: '17px' }}
                      >
                        <InputLabel htmlFor="type" className={classes.selectLabel} >
                          {'Symbol Group'}
                        </InputLabel>
                        <Select
                          value={this.state.form.groupId || -1}
                          MenuProps={{ className: classes.selectMenu }}
                          classes={{ select: classes.select }}
                          inputProps={{
                            onChange: event => this.change(event, "groupId"),
                            id: "groupId"
                          }}>
                          <MenuItem key={-1} value={-1}>
                            {''}
                          </MenuItem>
                          {Object.values(symbolGroups).map(item =>
                            <MenuItem key={item.symbolGroupId} value={item.symbolGroupId}>{item.name}</MenuItem>
                          )}
                        </Select>
                      </FormControl>
                    </GridItem>

                    <GridItem xs={12} sm={12} md={12} lg={10}>
                      <FormControl
                        fullWidth
                        className={classes.selectFormControl}
                      >
                        <InputLabel
                          htmlFor="simple-select"
                          className={classes.selectLabel}
                        >
                          Child Symbols
                      </InputLabel>
                        <Select
                          multiple
                          value={this.state.form.childrenSymbols}
                          MenuProps={{ className: classes.selectMenu }}
                          classes={{ select: classes.select }}
                          inputProps={{
                            onChange: event => this.change(event, 'childrenSymbols'),
                            id: "multiple-select"
                          }}>
                          {Object.values(allSymbols).map(item =>
                            <MenuItem key={item.symbolId} value={item.symbolId}>{item.name}</MenuItem>
                          )}
                        </Select>
                      </FormControl>
                    </GridItem>

                    <GridItem xs={12} sm={12} md={12} lg={10}>

                      <FormControl
                        fullWidth
                        className={classes.selectFormControl}
                        style={{ paddingTop: '27px', marginBottom: '17px' }}
                      >
                        <MultiInput
                          onUpdateValue={(newValues) => this.changeMultiselect(newValues)}
                          placeholder={'Alias'}
                          values={this.state.form.aliases}
                        />
                      </FormControl>
                    </GridItem>

                    <GridItem xs={12} sm={12} md={12} lg={10}>
                      <Button type="submit" className={classes.submit} color="success">Submit</Button>
                    </GridItem>
                  </GridContainer>
                </form>
                }
              </CardBody>
            </Card>
          </GridItem>
        </GridContainer>
    );
  }
}
const mapStateToProps = (state) => ({
  symbols: state.symbols,
  symbolGroups: state.symbolGroups.list,
  currencies: state.currencies.list
})
const mapDispatchToProps = (dispatch) => ({
  fetch: (id) => dispatch(symbolFetch(id)),
  fetchAll: () => dispatch(symbolsFetch()),
  save: (data) => dispatch(symbolSave(data)),
  danger: (text, sec) => dispatch(danger(text, sec)),
  success: (text, sec) => dispatch(success(text, sec)),
  currenciesFetch: () => dispatch(currenciesFetch()),
  currencyFilter: (filter) => dispatch(currencyFilter(filter)),
  symbolFilter: (filter) => dispatch(symbolFilter(filter)),
  fetchAllSymbols: () => dispatch(fetchAllSymbols()),
  symbolGroupsFetch: () => dispatch(symbolGroupsFetch()),
  symbolGroupFilter: (filter) => dispatch(symbolGroupFilter(filter)),
})
export default withStyles(styles)(connect(mapStateToProps, mapDispatchToProps)(Form));



// WEBPACK FOOTER //
// ./src/views/BaseSymbols/Form.jsx